







import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "UserAvatar",
  props: {
    size: Number as PropType<number>,
    user: Object as PropType<{ avatarUrl: string; firstName: string; lastName: string }>
  },
  computed: {
    initials(): string {
      if (this.user.firstName === undefined || this.user.lastName === undefined) {
        return "";
      }
      return `${this.user.firstName?.charAt(0)}${this.user.lastName?.charAt(0)}`;
    }
  }
});
